import { render } from "./RenameFile.vue?vue&type=template&id=6e214774"
import script from "./RenameFile.vue?vue&type=script&lang=js"
export * from "./RenameFile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__